// CloudFit: Hide out-of-stock size options
(function() {
  'use strict';

  function hideUnavailableOptions() {
    document.querySelectorAll('.product-options__value.disabled').forEach(function(el) {
      el.style.display = 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideUnavailableOptions);
  } else {
    hideUnavailableOptions();
  }

  document.addEventListener('change', function(e) {
    if (e.target.closest && e.target.closest('.js-product-options')) {
      setTimeout(hideUnavailableOptions, 200);
    }
  });

  document.addEventListener('product:variant-change', function() {
    setTimeout(hideUnavailableOptions, 200);
  });

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList && mutation.target.classList.contains('js-product-options')) {
        hideUnavailableOptions();
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var productOptions = document.querySelector('.js-product-options');
    if (productOptions) {
      observer.observe(productOptions, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  });
})();